<div class="actionwrapper">
    <div class="actions">
        <button mat-raised-button color="primary" (click)="add()">
            <mat-icon>add</mat-icon>
            Create new Group
        </button>
    </div>
</div>
<table class="table" mat-table matSort [dataSource]="tableDataSource">
    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
        <td class="cell" mat-cell *matCellDef="let item">{{item.id}}</td>
    </ng-container>
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
        <td class="cell" mat-cell *matCellDef="let item">{{item.name}}</td>
    </ng-container>
    <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description #</th>
        <td class="cell description" mat-cell *matCellDef="let item">
            {{item.description}}
        </td>
    </ng-container>
    <ng-container matColumnDef="memberType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td class="cell" mat-cell *matCellDef="let item">{{getTypeName(item.memberType)}}</td>
    </ng-container>
    <ng-container matColumnDef="actionmenu" stickyEnd>
        <th mat-header-cell matTooltip="Actions" *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item"><button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: item}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button></td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: columnNames"></tr>
    <mat-menu #menu="matMenu">
        <ng-template matMenuContent let-item="item">
            <button mat-menu-item (click)="edit(item)">Edit</button>
        </ng-template>
    </mat-menu>
</table>
